import useLangStore from '../stores/langStore';
export default function LangToggle({ className = '' }) {
  const { lang, setLang } = useLangStore();
  return (
    <div className={`flex items-center gap-1 rounded-full bg-slate-100 p-1 ${className}`}>
      {['sw','en'].map(l => (
        <button key={l} onClick={() => setLang(l)}
          className={`rounded-full px-3 py-1 text-xs font-bold transition-all ${
            lang === l ? 'bg-white text-emerald-800 shadow' : 'text-slate-500 hover:text-slate-700'
          }`}>
          {l === 'sw' ? '🇹🇿 SW' : '🇬🇧 EN'}
        </button>
      ))}
    </div>
  );
}
